"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var FormOrderCreationStrategy_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormOrderCreationStrategy = void 0;
const events_1 = require("../../events");
const typeorm_1 = require("typeorm/browser");
const form_1 = require("./form");
let FormOrderCreationStrategy = FormOrderCreationStrategy_1 = class FormOrderCreationStrategy {
};
FormOrderCreationStrategy.EVENTS = (0, events_1.makeEventsForClass)(FormOrderCreationStrategy_1);
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)('uuid'),
    __metadata("design:type", String)
], FormOrderCreationStrategy.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => form_1.Form, (item) => item.orderCreationStrategy),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", form_1.Form)
], FormOrderCreationStrategy.prototype, "form", void 0);
__decorate([
    (0, typeorm_1.Column)('uuid', {
        name: 'form_id',
        nullable: false,
    }),
    __metadata("design:type", String)
], FormOrderCreationStrategy.prototype, "formId", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'lax_validation',
        nullable: false,
        default: false,
    }),
    __metadata("design:type", Boolean)
], FormOrderCreationStrategy.prototype, "laxValidation", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], FormOrderCreationStrategy.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], FormOrderCreationStrategy.prototype, "updatedAt", void 0);
FormOrderCreationStrategy = FormOrderCreationStrategy_1 = __decorate([
    (0, typeorm_1.Entity)('form_order_creation_strategy', { schema: 'order_intake_forms' })
], FormOrderCreationStrategy);
exports.FormOrderCreationStrategy = FormOrderCreationStrategy;
//# sourceMappingURL=form-order-creation-strategy.js.map